export default __webpack_public_path__ + "static/media/calconvert_m3.7ed6b629.png";